export const facingMode: { [key: string]: string } = {
  front: 'user',
  back: 'environment',
};

export const debugTypes: Array<string> = ['0', '1', '2', '3', '900', '901', '902', '903'];

export const voiceParams: { [key: string]: number } = {
  channelCount: 1,
  sampleRate: 16000,
  sampleSize: 16
}
